import HSL from './HSL.js';
import RGB from './RGB.js';

var HEX = {
  isHex: function isHex(hex) {
    return /^#([A-Fa-f0-9]{3,4}){1,2}$/.test(hex);
  },
  toHSL: function toHSL(hex) {
    return RGB.toHSL(HEX.toRGB(hex));
  },
  toRGB: function toRGB(hex, alpha) {
    if (alpha) {
      var _HEX$toRGB = HEX.toRGB(hex),
        r = _HEX$toRGB.r,
        g = _HEX$toRGB.g,
        b = _HEX$toRGB.b;
      return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
    } else {
      var rgb = parseInt(hex.substring(1), 16); // strip # and convert rrggbb to decimal
      var red = rgb >> 16 & 0xff; // extract red
      var green = rgb >> 8 & 0xff; // extract green
      var blue = rgb >> 0 & 0xff; // extract blue
      return {
        r: red,
        g: green,
        b: blue
      };
    }
  },
  saturate: function saturate(hex, amount) {
    if (amount === void 0) {
      amount = 10;
    }
    return HSL.toHEX(HSL.saturate(HEX.toHSL(hex), amount));
  },
  desaturate: function desaturate(hex, amount) {
    if (amount === void 0) {
      amount = 10;
    }
    return HSL.toHEX(HSL.desaturate(HEX.toHSL(hex), amount));
  },
  darken: function darken(hex, amount) {
    if (amount === void 0) {
      amount = 10;
    }
    return HSL.toHEX(HSL.darken(HEX.toHSL(hex), amount));
  },
  lighten: function lighten(hex, amount) {
    if (amount === void 0) {
      amount = 10;
    }
    return HSL.toHEX(HSL.lighten(HEX.toHSL(hex), amount));
  }
};

export { HEX as default };
//# sourceMappingURL=HEX.js.map
